// ============================================
// SECTOR CHART COMPONENT
// ============================================
// Horizontal bar chart showing lead distribution by sector
// ============================================

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList
} from 'recharts';

const SectorChart = ({ data }) => {
  // Sector colors
  const COLORS = [
    '#3b82f6', // blue
    '#10b981', // emerald
    '#f59e0b', // amber
    '#8b5cf6', // purple
    '#ef4444', // red
    '#06b6d4', // cyan
    '#ec4899', // pink
    '#84cc16', // lime
  ];

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const total = payload[0].payload.totalLeads || 0;
      const percentage = total > 0 ? ((data.count / total) * 100).toFixed(1) : 0;
      
      return (
        <div className="bg-slate-800 border border-slate-700 rounded-lg p-3 shadow-lg">
          <p className="text-slate-300 text-sm font-medium mb-2">
            {data.sector}
          </p>
          <p className="text-white text-sm">
            Leads: {data.count}
          </p>
          <p className="text-slate-400 text-xs">
            Revenue: R{data.revenue?.toLocaleString() || 0}
          </p>
          <p className="text-slate-400 text-xs">
            {percentage}% of total
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart 
        data={data} 
        layout="vertical"
        margin={{ top: 5, right: 30, left: 150, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis 
          type="number"
          stroke="#94a3b8"
          style={{ fontSize: '12px' }}
        />
        <YAxis 
          type="category"
          dataKey="sector" 
          stroke="#94a3b8"
          width={150}
          style={{ fontSize: '11px' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar 
          dataKey="count" 
          radius={[0, 8, 8, 0]}
        >
          <LabelList 
            dataKey="count" 
            position="right" 
            style={{ fill: '#f1f5f9', fontSize: '11px', fontWeight: 'bold' }}
          />
          {data.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={COLORS[index % COLORS.length]} 
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SectorChart;